import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { store } from "@/store/store";
import { AVAILABLE_COMPANIES_QUERY, AvailableCompaniesResult, Company } from "@/models/queries/AvailableCompaniesQuery";
import { graphqlClient } from "@/utils/graphql";

interface CompanyStoreState {
  availableCompanies: Company[];
}

@Module({ dynamic: true, store, name: "companyStore" })
class CompanyS extends VuexModule implements CompanyStoreState {
  public availableCompanies: Company[] = [];

  @Mutation
  private DID_FETCH_COMPANIES(companies: Company[]) {
    this.availableCompanies.splice(0, this.availableCompanies.length); // clear
    this.availableCompanies.push(...companies);
  }

  @Action
  public async loadAvailableCompanies() {
    const result = await graphqlClient.query<AvailableCompaniesResult>({
      query: AVAILABLE_COMPANIES_QUERY
    });
    if (result && result.data && !result.errors) {
      this.DID_FETCH_COMPANIES(result.data.availableCompanies);
    }
  }
}

export const CompanyStore = getModule(CompanyS);
